import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import { NgControl } from '@angular/forms';


@Directive({
    selector: '[currencyFormat]'
})
export class CurrencyFormatDirective implements OnInit {

    private readonly COMMA_SEP_REGEX = /,/g;
    private readonly DECIMAL_SEP = '.';
    private readonly DEFAULT_DIGIT_INFO = "1.0-2";
    // allowing [backspace, tab, enter, escape, end, home, left arrow, right arrow, delete, decimal point, period]
    private readonly allowedKeys = [8, 9, 13, 27, 35, 36, 37, 39, 46, 110, 190];
    // allowing ctrl + [a, c, v, x]
    private readonly ctrlAllowedKeys = [65, 67, 86, 88];
    private el: any;

    /**
     * To provide custom digit info to format currency instead of the default #DEFAULT_DIGIT_INFO
     * e.g.
     * for custom:  <input type="text" [currencyFormat]="'2.0-3'" />
     * for default: <input type="text" currencyFormat />
     */
    @Input('currencyFormat')
    digitInfo: string;

    constructor(
        private _elementRef: ElementRef,
        private ngControl: NgControl,
        private decimalPipe: DecimalPipe
    ) {
        this.el = this._elementRef.nativeElement;
    }

    ngOnInit() {
        this.el.value = this.decimalPipe.transform(this.removeComma(this.el.value), this.digitInfo || this.DEFAULT_DIGIT_INFO);
    }

    @HostListener('blur', ['$event', '$event.target.value'])
    public onBlur(event, value) {
        this.el.value = this.decimalPipe.transform(this.removeComma(value), this.digitInfo || this.DEFAULT_DIGIT_INFO);
        event.preventDefault();

        this.ngControl.control.setValue(this.removeComma(this.el.value), {
            emitEvent: false,
            emitModelToViewChange: false,
            emitViewToModelChange: false
        });
    }

    @HostListener('keydown', ['$event'])
    public onKeyDown(evt) {
        let event = <KeyboardEvent>evt;
        let key = event.keyCode || event.which;
        let ctrl = event.ctrlKey || event.metaKey; // Mac support

        // to check wheather key is from 0-9 from main keyboard pad
        let isZeroToNineMainPad = key >= 48 && key <= 57;

        // to check wheather key is from 0-9 from num pad
        let isZeroToNineNumPad = key >= 96 && key <= 105;

        // check if key is decimal point = 110 or period = 190
        let isDecimalKeys = key == 190 || key == 110;

        // only one decimal separator is allowed
        let isDecimalAlreadyAdded = isDecimalKeys && this.ngControl.control
            && this.ngControl.control.value.indexOf(this.DECIMAL_SEP) > -1;

        if (!((!event.shiftKey && !event.altKey)
            && (isZeroToNineMainPad
                || isZeroToNineNumPad
                || this.allowedKeys.indexOf(key) !== -1
                || (ctrl && this.ctrlAllowedKeys.indexOf(key) !== -1))
            && !isDecimalAlreadyAdded)) {
            event.preventDefault();
        }
    }

    private removeComma(value) {
        if (!_.isEmpty(value)) {
            return value.replace(this.COMMA_SEP_REGEX, "");
        } else {
            return "";
        }
    }
}
